import { IneligibleCoverageReasonsType } from "config";
import { gql } from "config/graphql";
import { UNDERWRITING_AVAILABILITY_FIELDS } from "gql/fragments";
import { gqlQuery } from "store/apollo";

interface IAccountCapabilitiesResponse {
  data: {
    me: {
      activeConstellations: {
        activeInsuranceMembership: {
          capabilities: {
            billing: boolean;
            termLifeExtension: boolean;
          };
        };
      }[];
    };
  };
}

export const fetchAccountCapabilities = () => {
  const query = gql`
    query accountCapabilities {
      me {
        activeConstellations {
          activeInsuranceMembership {
            capabilities {
              billing
              termLifeExtension
            }
          }
        }
      }
    }
  `;

  return gqlQuery<IAccountCapabilitiesResponse["data"]>({ query });
};

export interface IIneligibleForCoverageReasonsResponse {
  data: {
    userIneligibleReasons: {
      ineligibleCoverageReasons: IneligibleCoverageReasonsType[];
    };
  };
}

export const fetchIneligibleForCoverageReasons =
  (): Promise<IIneligibleForCoverageReasonsResponse> => {
    const query = gql`
      query fetchIneligibleForCoverageReasons {
        userIneligibleReasons {
          ineligibleCoverageReasons
        }
      }
    `;

    return gqlQuery<IIneligibleForCoverageReasonsResponse["data"]>({ query });
  };

interface IFetchUnderwritingAvailabilityResponse {
  data: {
    me: {
      coverageAdjustmentAvailable: boolean;
      reinstatementAvailable: boolean;
    };
  };
}

export const fetchUnderwritingAvailability =
  (): Promise<IFetchUnderwritingAvailabilityResponse> => {
    const query = gql`
      ${UNDERWRITING_AVAILABILITY_FIELDS}
      query fetchUnderwritingAvailability {
        me {
          ...UnderwritingAvailabilityFields
        }
      }
    `;

    return gqlQuery<IFetchUnderwritingAvailabilityResponse["data"]>({
      fetchPolicy: "no-cache",
      query,
    });
  };
